import { BulkSlideTagOperation, BulkSlideTagResultScopeMode } from 'api/slideTags';

export const TAG_VALUE_OPERATIONS: BulkSlideTagOperation[] = ['add', 'remove', 'override'];

export const operationLabels: Record<BulkSlideTagOperation, string> = {
  add: 'Add',
  remove: 'Remove',
  override: 'Override',
  clear: 'Clear',
};

export const operationDescriptions: Record<BulkSlideTagOperation, string> = {
  add: 'Add selected tags where they are missing.',
  remove: 'Remove selected tags where they are present.',
  override: 'Replace tags in the selected tag scopes.',
  clear: 'Remove all slide tag assignments from selected slides.',
};

export const resultScopeLabels: Record<BulkSlideTagResultScopeMode, string> = {
  filter: 'Use filter orchestration',
  explicit: 'Choose orchestration',
  approved_per_slide: 'Approved per slide',
};

export const previewTagScopeLabels: Record<string, string> = {
  global: 'Global',
  study: 'Study',
  experiment_result: 'Result',
};
